import React from 'react'

const ModalFaltoCamposPorDiligenciarListaChequeo = ({setmodalOnFaltoDiligenciarCampos, dataListaChequeo, validarAlergiasSiEsSi}) => {
    const handleCancelarClick=()=>{
        setmodalOnFaltoDiligenciarCampos(false)
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto pt-20 bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md">
            <h5
              className="text-xl font-medium leading-normal text-gray-800"
              id="exampleModalScrollableLabel"
            ></h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>

          <div className="flex-auto overflow-y-auto relative mt-3 text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-300">
              <svg fill="currentColor" viewBox="0 0 20 20" className="h-6 w-6">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <h3 className="text-lg leading-6 font-medium text-red-900">
            Falto diligenciar estos campos:
            </h3>
            <div className=" px-7 ">
              <ul>
                {/* <li className="text-sm text-red-500 text-left"> {dataListaChequeo.tipoSangre? null: '* ' + 'Tipo sangre'}</li> */}
                {/* <li className="text-sm text-red-500 text-left"> {dataListaChequeo.cualesAlergias? null: '* ' + 'Cuales alergias'}</li>                   */}
                <li className="text-sm text-red-500 text-left"> {validarAlergiasSiEsSi? null: '* ' + 'Cuales alergias'}</li>
                <li className="text-sm text-red-500 text-left"> {dataListaChequeo.frecuenciaCardiaca? null: '* ' + 'Frecuencia cardiaca'}</li> 
                <li className="text-sm text-red-500 text-left"> {dataListaChequeo.saturacionOxigeno? null: '* ' + '% Saturación de oxigeno'}</li> 
                <li className="text-sm text-red-500 text-left"> {dataListaChequeo.temperatura? null: '* ' + 'Temperatura'}</li>                
                <li className="text-sm text-red-500 text-left"> {dataListaChequeo.presionSistolica? null: '* ' + 'Presión sistólica'}</li>
                <li className="text-sm text-red-500 text-left"> {dataListaChequeo.presionDiastolica? null: '* ' + 'Presión diastólica'}</li>
                {/* <li className="text-sm text-red-500 text-left"> {dataListaChequeo.peso? null: '* ' + 'Peso (Kg)'}</li>
                <li className="text-sm text-red-500 text-left"> {dataListaChequeo.talla? null: '* ' + 'Talla (cm)'}</li> */}
                
              </ul>
            </div>
            <div className="items-center px-4 py-3">
              <button
                type="button"
                onClick={handleCancelarClick}
                id="ok-btn"
                className="px-4 py-2 bg-red-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-300"
              >
                OK
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  )
}

export default ModalFaltoCamposPorDiligenciarListaChequeo